export const AUTOBATCH_POPUP_TEXT = {
	title: 'Segments automatically merged',
	subtitle: 'New work assignment has been created',
	body: 'The system detected the same driver for consecutive segments and combined them into one work assignment.',
	buttonLabel: 'Got it',
	imageAlt: 'New work assignment created vizualization',
};

export const AUTOBATCH_POPUP_ARIA = {
	popupId: 'autobatch-popup',
	labelId: 'segments-automatically-merged',
	titleId: 'autobatch-popup-title',
	subtitleId: 'validation-popup-subtitle',
};
